import { render, staticRenderFns } from "./registrationCompleted.vue?vue&type=template&id=091b09c3&"
import script from "./registrationCompleted.vue?vue&type=script&lang=js&"
export * from "./registrationCompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports